export const removeTokens = () => {
  localStorage.removeItem("accesstoken");
  localStorage.removeItem("refreshtoken");
};
